import React from 'react'
import { Button } from '@/components/ui/button'
import { Spinner } from '@/components/ui/spinner'
import {
  FormBaseButtonContainer,
  FormBaseContainer,
  FormBaseErrorMessage,
  FormBaseFieldBlock,
  FormBaseFieldGroup,
  FormBaseFieldLabel,
  FormBaseRow,
} from 'components/Form/Form.styles'
import { Field, Form, FormikErrors, FormikProps, withFormik } from 'formik'

interface RemoveMarginBonusCreditFormValues {
  amount: number
}

interface OuterProps {
  credit: number
  onClose: () => void
  onSubmit(amount: number): Promise<void>
}

type RemoveMarginBonusCreditFormProps = FormikProps<RemoveMarginBonusCreditFormValues> & OuterProps

const MarginBonusCreditRemovalFormUI: React.FC<RemoveMarginBonusCreditFormProps> = (props) => {
  const { errors, credit } = props

  return (
    <FormBaseContainer>
      <Form>
        <FormBaseFieldBlock>
          <FormBaseRow>
            <FormBaseFieldLabel>Current Credit Balance:</FormBaseFieldLabel>
            <FormBaseFieldGroup>
              <Field disabled value={credit.toFixed(2)} />
            </FormBaseFieldGroup>
          </FormBaseRow>
        </FormBaseFieldBlock>

        <FormBaseFieldBlock>
          <FormBaseRow>
            <FormBaseFieldLabel>Amount to be Removed </FormBaseFieldLabel>
            <FormBaseFieldGroup>
              <Field
                name='amount'
                type='number'
                min='0'
                step='0.01'
                placeholder='Enter amount'
                data-test='amount-field'
              />
            </FormBaseFieldGroup>
          </FormBaseRow>
          {errors.amount && <FormBaseErrorMessage>{errors.amount}</FormBaseErrorMessage>}
        </FormBaseFieldBlock>

        <FormBaseButtonContainer>
          <Button
            variant='destructive'
            type='submit'
            key='button'
            disabled={!!errors.amount || props.values.amount <= 0 || props.isSubmitting}
          >
            Remove Credit
            {props.isSubmitting && <Spinner />}
          </Button>
        </FormBaseButtonContainer>
      </Form>
    </FormBaseContainer>
  )
}

export const RemoveMarginBonusCreditForm = withFormik<
  OuterProps,
  RemoveMarginBonusCreditFormValues
>({
  mapPropsToValues: () => ({
    amount: 0,
    comment: '',
    addCampaignRestriction: false,
  }),
  handleSubmit: async (values, { props, setSubmitting }) => {
    try {
      await props.onSubmit(values.amount)
      props.onClose()
    } finally {
      setSubmitting(false)
    }
  },
  validate: (values, props) => {
    const errors: FormikErrors<RemoveMarginBonusCreditFormValues> = {}

    if (!values.amount || values.amount <= 0) {
      errors.amount = 'Amount must be greater than 0'
    }

    if (values.amount > props.credit) {
      errors.amount = 'Amount cannot exceed current credit balance'
    }

    return errors
  },
  enableReinitialize: true,
})(MarginBonusCreditRemovalFormUI)
